/* Aino size attribution in native product form, survives page reload. */
(() => {
 'use strict';
 const key='disturb:aino:native-size:v1';
 const field='properties[_aino_size_recommendation]';
 const digits=v=>String(v||'').match(/([0-9]+)$/)?.[1]||'';
 document.addEventListener('disturb:aino-size-recommended',event=>{
  const variantId=digits(event.detail?.variantId);
  if(!variantId||event.detail?.path!==location.pathname)return;
  try{sessionStorage.setItem(key,JSON.stringify({variantId,path:location.pathname,time:Date.now()}));}catch{}
 });
 document.addEventListener('submit',event=>{
  const form=event.target;
  if(!(form instanceof HTMLFormElement))return;
  let action;
  try{action=new URL(form.action,location.href).pathname;}catch{return;}
  if(!action.endsWith('/cart/add'))return;
  const variantId=digits(new FormData(form).get('id'));
  let record=null;
  try{record=JSON.parse(sessionStorage.getItem(key)||'null');}catch{}
  const valid=Boolean(record&&record.path===location.pathname&&Date.now()-record.time<7200000&&record.variantId===variantId&&variantId);
  let input=form.querySelector('input[name="'+field+'"]');
  if(valid){
   if(!input){input=document.createElement('input');input.type='hidden';input.name=field;form.appendChild(input);}
   input.value='Kokosuositusta käytetty';
  }else if(input)input.remove();
 },true);
})();